import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Login from '../pages/login'

export const LoginRoute = () => {
    return (
        <Switch>
            {/* Ruta genérica sin tenant */}
            <Route exact path='/login' component={Login} />
            
            {/* Ruta con tenant dinámico - CUALQUIER empresa */}
            <Route 
                exact 
                path='/:tenant([a-zA-Z0-9\-_]+)/login' 
                render={(props) => (
                    <Login {...props} tenant={props.match.params.tenant} />
                )}
            />
        </Switch>
    )
}